import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Checkbox, FormControl, FormControlLabel, Grid } from '@material-ui/core';
import { btMediumGrayColor } from '../../../assets/jss/nextjs-material-kit-pro';
import { stripLeadingNumber, isAdminOrFHT, isStudent, isAlumni, isFHT } from '../../../util/miscUtil';

const styles = makeStyles(() => ({
  checklistRow: {
    margin: '10px 0',
    padding: '15px 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  checklistColumn: {
    alignItems: 'center',
  },
  checkboxCell: {
    display: 'flex',
    alignItems: 'flex-start',
    marginTop: 0,
  },
  pointsLabel: {
    fontSize: '1.00rem',
    lineHeight: 1.5,
    fontWeight: 400,
    color: btMediumGrayColor,
  },
  dueLabel: {
    fontSize: '1.00rem',
    lineHeight: 1.5,
    fontWeight: 400,
    color: btMediumGrayColor,
  },
  datePickerRowSpacer: {
    height: 50,
    paddingTop: 8,
    marginBottom: 10,
  },
  datepicker: {
    width: '160px',
    '& .MuiFilledInput-root': {
      background: 'rgb(255, 255, 255)',
    },
  },
  printedContent: {
    '@media print': {
      marginBottom: 10,
    },
    '@media screen': {
      display: 'none',
    },
  },
  unprintedContent: {
    '@media print': {
      display: 'none',
    },
    '@media screen': {},
  },
  alignPrintedContent: {
    verticalAlign: 'top',
    fontSize: '1.00rem',
    lineHeight: 1.5,
    fontWeight: 400,

    marginTop: 5,
  },
  underline: {
    margin: '5px 0',
    borderBottom: '1px solid #000',
  },
  checkOutline: {
    border: '1px solid #000',
    borderRadius: 6,
    maxWidth: '35px',
    alignContent: 'center',
    minWidth: '35px',
  },
  subtleBold: {
    fontWeight: 500,
    color: btMediumGrayColor,
  },
}));

function renderChecklistItem(item, form, setForm, classes, isFieldDisabled, isConfirmDisabled, number) {
  const label = stripLeadingNumber(item.label);
  const due = item.due;

  if (item.key === 'secCareerHSRequirement') {
    return [
      <Grid
        container
        direction="row"
        alignItems="center"
        style={{ marginBottom: 10 }}
        className={classes.unprintedContent + ' ' + classes.checkListRow}
        key="secCareerHSRequirement-unprinted"
      >
        <Grid item xs={12} sm={12} md={8} lg={8} className={classes.checklistColumn}>
          <main>
            <ul>
              <li>{label}</li>
            </ul>
          </main>
        </Grid>
        <Grid item xs={3} sm={3} md={1} lg={1} align="right" style={{ paddingRight: '3%' }} className={classes.checklistColumn}></Grid>
        <Grid item xs={6} sm={6} md={2} lg={2} align="left" className={classes.checklistColumn}>
          <div className={classes.dueLabel}>{due}</div>
        </Grid>
        <Grid item xs={3} sm={3} md={1} lg={1} align="right" style={{ paddingRight: '2.5%' }} className={classes.checklistColumn}></Grid>
      </Grid>,
      <Grid container direction="row" className={classes.printedContent + ' ' + classes.underline} key="secCareerHSRequirement-printed">
        <Grid item xs={7}>
          <main>
            <ul>
              <li>{label}</li>
            </ul>
          </main>
        </Grid>
        <Grid item xs={2} align="right" style={{ paddingRight: 40 }}>
          <div className={classes.alignPrintedContent}></div>
        </Grid>
        <Grid item xs={3}>
          <div className={classes.alignPrintedContent}>{due}</div>
        </Grid>
      </Grid>,
    ];
  }
  if (item.key === 'secCareerExploreOptions') {
    return [
      <Grid
        container
        direction="row"
        alignItems="center"
        style={{ marginBottom: 10 }}
        className={classes.unprintedContent + ' ' + classes.checkListRow}
        key="secCareerExploreOptions-unprinted"
      >
        <Grid item xs={12} sm={12} md={8} lg={8} className={classes.checklistColumn}>
          <main>
            <ul>
              <li>{label}</li>
            </ul>
          </main>
        </Grid>
        <Grid item xs={3} sm={3} md={1} lg={1} align="right" style={{ paddingRight: '3%' }} className={classes.checklistColumn}></Grid>
        <Grid item xs={6} sm={6} md={2} lg={2} align="left" className={classes.checklistColumn}>
          <div className={classes.dueLabel}>{due}</div>
        </Grid>
        <Grid item xs={3} sm={3} md={1} lg={1} align="right" style={{ paddingRight: '2.5%' }} className={classes.checklistColumn}></Grid>
      </Grid>,
      <Grid container direction="row" className={classes.printedContent + ' ' + classes.underline} key="secCareerExploreOptions-printed">
        <Grid item xs={7}>
          <main>
            <ul>
              <li>{label}</li>
            </ul>
          </main>
        </Grid>
        <Grid item xs={2} align="right" style={{ paddingRight: 40 }}>
          <div className={classes.alignPrintedContent}></div>
        </Grid>
        <Grid item xs={3}>
          <div className={classes.alignPrintedContent}>{due}</div>
        </Grid>
      </Grid>,
    ];
  }
  return (
    <Grid
      container
      direction="row"
      alignItems="center"
      style={{ marginBottom: 10 }}
      className={classes.unprintedContent + ' ' + classes.checkListRow}
      key={item.key}
    >
      <Grid item xs={12} sm={12} md={8} lg={8} className={classes.checklistColumn}>
        <FormControl fullWidth>
          <FormControlLabel
            control={<Checkbox color="default" style={{ alignSelf: 'flex-start' }} />}
            label={`${number}. ${stripLeadingNumber(item.label)}`}
            disabled={isFieldDisabled(form[item.confirmKey])}
            checked={form[item.key]}
            onChange={() => setForm({ ...form, [item.key]: !form[item.key] })}
          />
        </FormControl>
      </Grid>
      <Grid item xs={3} sm={3} md={1} lg={1} align="right" style={{ paddingRight: '3%' }} className={classes.checklistColumn}>
        <div className={classes.pointsLabel}>{item.points}</div>
      </Grid>
      <Grid item xs={6} sm={6} md={2} lg={2} align="left" className={classes.checklistColumn}>
        <div className={classes.dueLabel}>{item.due}</div>
      </Grid>
      <Grid item xs={3} sm={3} md={1} lg={1} align="right" style={{ paddingRight: '2.5%' }} className={classes.checklistColumn}>
        <Checkbox
          color="default"
          disabled={isConfirmDisabled(form[item.key])}
          checked={form[item.confirmKey]}
          onChange={() => setForm({ ...form, [item.confirmKey]: !form[item.confirmKey] })}
        ></Checkbox>
      </Grid>
    </Grid>
  );
}

export default function PostSecondaryCareerItems(props) {
  const { form, setForm, auth, startIndex = 1, points, formClasses, items } = props;

  const classes = styles();

  const hasItems = items && items.length > 0;

  const isFieldDisabled = () => {
    return !!isAdminOrFHT(auth.roles);
  };

  const isConfirmDisabled = () => {
    return !!(isStudent(auth.roles) || isAlumni(auth.roles) || isFHT(auth.roles));
  };
  // Only increment number for non-instruction items
  let number = startIndex;
  return (
    <React.Fragment>
      {hasItems && (
        <Grid container direction="row" className={formClasses.sectionSpacer}>
          <Grid item xs={7} align="left">
            <section align="left" className={formClasses.sectionTitle}>
              Post-Secondary Career Training Option
            </section>
          </Grid>
          <Grid item xs={2}>
            <section align="right" className={formClasses.sectionTitle}>
              <div style={{ fontSize: '1.15rem', fontWeight: 600, paddingRight: '30px' }}>{points}</div>
            </section>
          </Grid>
          <Grid item xs={3}>
            <section align="center" className={formClasses.sectionTitle}>
              <br />
            </section>
          </Grid>
        </Grid>
      )}
      {hasItems &&
        items.map((item) => {
          if (item.type !== 'instruction') {
            const rendered = renderChecklistItem(item, form, setForm, classes, isFieldDisabled, isConfirmDisabled, number);
            number++;
            return rendered;
          } else {
            return renderChecklistItem(item, form, setForm, classes, isFieldDisabled, isConfirmDisabled, '');
          }
        })}
    </React.Fragment>
  );
}

PostSecondaryCareerItems.propTypes = {
  form: PropTypes.object,
  setForm: PropTypes.func,
  auth: PropTypes.object,
  startIndex: PropTypes.number,
  points: PropTypes.number,
  formClasses: PropTypes.object,
  items: PropTypes.array,
};
